import * as Yup from 'yup'

export const AdvertiserMarginSchema = Yup.object().shape({
  advertiser_margin: Yup.number().required('This field is required.'),
});

export const InfluencerPayoutMarginSchema = Yup.object().shape({
  influencer_payout_margin: Yup.number().required('This field is required.'),
});
